import { Locale } from "./locale.type";

const sv: Locale = {
  title: "East Landscape",
  locale: {
    english: "Engelska",
    swedish: "Svenska",
  },
  localeShort: {
    english: "en",
    swedish: "sv",
  },
  about: "Om East",
  portfolio: "Portfolio",
  contact: "Kontakt",
};

export default sv;
